module.exports = __webpack_public_path__ + "img/kaoshixuzhi_img@2x.2dca2299.png";